import React from 'react';
import { CoinsIcon, LayersIcon, LineChartIcon, UsersIcon, WalletIcon, WrenchIcon } from 'lucide-react';
import { products } from '../data/content';
import type { ProductIcon } from '../types/landing';
import { Reveal } from './Reveal';
const iconMap: Record<ProductIcon, React.ComponentType<{
  className?: string;
}>> = {
  wallet: WalletIcon,
  candles: LineChartIcon,
  layers: LayersIcon,
  users: UsersIcon,
  coins: CoinsIcon,
  tools: WrenchIcon
};
export function ProductsSection() {
  const [featured, ...rest] = products;
  const FeaturedIcon = iconMap[featured.icon];
  return <section id="productos" className="px-5 py-24 lg:px-8 lg:py-32" data-id="element-210" data-mp="1vqhjg509drno">
      <div className="mx-auto max-w-shell" data-id="element-211" data-mp="20osugj2ai87h">
        <Reveal data-id="element-212" data-mp="20pkbmov543e8">
          <h2 className="max-w-[620px] text-[32px] font-extrabold uppercase leading-[1] tracking-tightest text-white sm:text-[44px]" data-id="element-213" data-mp="20p1667mof7h3">
            Mucho más que comprar crypto.
          </h2>
          <p className="mt-5 max-w-[560px] text-[15px] leading-relaxed text-ink-muted" data-id="element-214" data-mp="3v2a73b15pknq">
            Descubre diferentes herramientas y productos disponibles dentro del ecosistema de Bybit.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 lg:grid-cols-3" data-id="element-215" data-mp="338df9nyid9w8">
          <Reveal className="lg:col-span-2" data-id="element-216" data-mp="3hycdfqq2clbp">
            <article className="glass flex h-full flex-col justify-between overflow-hidden rounded-3xl p-7 lg:p-9" data-id="element-217" data-mp="3i16wpexcc03j">
              <div className="flex items-start justify-between gap-6" data-id="element-218" data-mp="2paos29gyxqo0">
                <span className="text-[11px] font-semibold tracking-[0.2em] text-brand" data-id="element-219" data-mp="2pcsxwwyfgzqx">
                  {featured.number}
                </span>
                <FeaturedIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-220" data-mp="2ybn2b9i02uf1" />
              </div>
              <div className="mt-14 lg:mt-20" data-id="element-221" data-mp="2u9jncaw4h7p0">
                <h3 className="text-[26px] font-bold uppercase leading-tight tracking-tightest text-white lg:text-[32px]" data-id="element-222" data-mp="2ubw2yheer5yw">
                  {featured.title}
                </h3>
                <p className="mt-3 max-w-[420px] text-[14.5px] leading-relaxed text-ink-muted" data-id="element-223" data-mp="9j0zeq8zmkb0">
                  {featured.description}
                </p>
              </div>
            </article>
          </Reveal>

          <div className="grid gap-4" data-id="element-224" data-mp="37bawwqq9e1a3">
            {rest.slice(0, 2).map((product, i) => <ProductCard key={product.number} product={product} delay={0.06 + i * 0.05} data-id="element-225" data-mp="3cd057ym3k0uh" data-mpi={i} />)}
          </div>

          {rest.slice(2).map((product, i) => <ProductCard key={product.number} product={product} delay={0.16 + i * 0.05} data-id="element-226" data-mp="2jom6thr3j2ie" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}
function ProductCard({
  product,
  delay
}: {
  product: (typeof products)[number];
  delay: number;
}) {
  const Icon = iconMap[product.icon];
  return <Reveal delay={delay} className="h-full" data-id="element-227" data-mp="2xfrcb0h5ap0n">
      <article className="flex h-full flex-col rounded-3xl border border-hairline bg-card/60 p-6 transition-[border-color,background-color,transform] duration-200 ease-smooth hover:-translate-y-0.5 hover:border-brand/35 hover:bg-card" data-id="element-228" data-mp="2xgsl0yaouzf7">
        <div className="flex items-center justify-between gap-4" data-id="element-229" data-mp="1xfe3xz1zcgk7">
          <span className="text-[11px] font-semibold tracking-[0.2em] text-brand" data-id="element-230" data-mp="1sg1fxazdh3g1">
            {product.number}
          </span>
          <Icon className="h-4 w-4 text-ink-muted" aria-hidden="true" data-id="element-231" data-mp="1odoayosg99kb" />
        </div>
        <h3 className="mt-6 text-[17px] font-bold uppercase tracking-tightest text-white" data-id="element-232" data-mp="1jfw9b320692x">
          {product.title}
        </h3>
        <p className="mt-2.5 text-[13.5px] leading-relaxed text-ink-muted" data-id="element-233" data-mp="1eh1t88vf6ymi">{product.description}</p>
      </article>
    </Reveal>;
}